<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path+(tag.query&&tag.query.openNew&&tag.query.key?tag.query.key:'')"
        :class="isActive(tag)?'active':''"
        :to="tag"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ getLangMetaTitle(tag.meta) }}
        <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">
        {{ $t('tagsView.refresh') }}
      </li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">
        {{
          $t('tagsView.close') }}
      </li>
      <li @click="closeOthersTags">
        {{ $t('tagsView.closeOthers') }}
      </li>
      <li @click="closeAllTags(selectedTag)">
        {{ $t('tagsView.closeAll') }}
      </li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import { generateTitle } from '@/utils/i18n'
import { MessageBox } from 'element-ui'
import path from 'path'
import { mapGetters } from 'vuex'
import { matchView, refreshView, destoryView } from '@/store/modules/tagsView'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLangMetaTitle } from '@/utils/langUtil'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
    isZh() {
      return this.language === 'zh'
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.params.replace) {
        delete newVal.params.replace
        this.replaceTags(oldVal, newVal)
      } else {
        this.addTags()
      }
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    getLangMetaTitle,
    generateTitle, // generateTitle by vue-i18n
    isActive(route) {
      // 存在同名常量路由与动态菜单路由（如 UnlockLedger: /UnlockLedger 与 /Clearing/UnlockLedger），
      // 缓存 view 的 path 可能与当前 $route.path 不一致导致 matchView 误判，
      // 故先按 name+fullPath 精确判定是否为当前路由
      if (route.name && route.name === this.$route.name && route.fullPath === this.$route.fullPath) {
        return true
      }
      return matchView(route, this.$route)
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addView', tag)
        }
      }
    },
    addTags() {
      // this.$store.dispatch('app/closeSideBar')
      const { name } = this.$route
      if (name && name.toLowerCase() !== 'dashboard') {
        this.$store.dispatch('app/closeSideBar')
      }
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    replaceTags(oldView, newView) {
      // this.$store.dispatch('app/closeSideBar')
      const { name } = newView
      if (name && name.toLowerCase() !== 'dashboard') {
        this.$store.dispatch('app/closeSideBar')
      }
      if (name) {
        this.$store.dispatch('tagsView/replaceView', { oldView, newView })
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (matchView(tag.to, this.$route)) {
            this.$refs.scrollPane.moveToTarget(tag)
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      destoryView(view)
      refreshView(view)
    },
    closeSelectedTag(view) {
      if (!this.$store.state.app.canCloseModule && view.name === 'BookingNew') {
        MessageBox.alert(this.$t('Message.PleaseExitTheEditingModule'), {
          confirmButtonText: this.$t('Invoice.invoice_confirm'),
          type: 'warning' })
      } else if (this.$store.state.app.canCloseModuleMap && this.$store.state.app.canCloseModuleMap.size > 0) {
        let key = view.name
        if (key) {
          // 支持打开多票业务模式时，要拼接业务编号(目前只有海出支持打开多票业务)
          if (key === SystemConstants.CLOSE_MODULE_SE && view.query && view.query.key) {
            key = key + '_' + view.query.key
          }
          if (this.$store.state.app.canCloseModuleMap.has(key)) {
            MessageBox.alert(this.$t('Message.PleaseExitTheEditingModule'), {
              confirmButtonText: this.$t('Invoice.invoice_confirm'),
              type: 'warning' })
          } else {
            this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
              if (this.isActive(view)) {
                this.toLastView(visitedViews)
              }
            })
          }
        } else {
          this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
            if (this.isActive(view)) {
              this.toLastView(visitedViews)
            }
          })
        }
      } else {
        this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews)
          }
        })
      }
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => matchView(tag, view))) {
          return
        }
        this.toLastView(visitedViews)
      })
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        // 用 fullPath 字符串跳转：缓存的 view 对象可能携带与当前路由表不一致的 name/params/path，
        // 直接 push 对象会走 name 匹配引发歧义；path 字符串始终按路由表解析，规避同名路由问题
        this.$router.push(latestView.fullPath || latestView.path)
      } else {
        // You can set another route
        this.$router.push('/')
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  .tags-view-wrapper {
    .el-scrollbar__bar {
      &.is-horizontal {
        height: 0;
      }
    }
    .el-scrollbar__wrap {
      overflow: auto!important;
      margin-bottom: 0!important;
      height: 52px;

    }
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      line-height: 31px;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-top: 4px;
      &:first-of-type {
        margin-right: 5px;
        margin-left: 15px;
        border-right: 1px solid $--border-color-base;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &:hover{
        background-color: $--color-primary!important;
        color: #FFFFFF!important;
      }
      &.active {
        background-color: #E8F1FB;
        color: $--color-primary;
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      position: relative;
      top:-1px;
      width: 16px;
      height: 16px;
      font-size: 16px;
      vertical-align: middle;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
